import ForbiddenErrorPage from "./forbidden-error-page/ForbiddenErrorPage";
import GenericErrorPage from "./GenericErrorPage";
import InternalErrorPage from "./InternalErrorPage";
import NotFoundErrorPage from "./NotFoundErrorPage";

export const getErrorPageFromStatus = (status) => {
  switch (status) {
    case 403:
      return ForbiddenErrorPage;
    case 404:
      return NotFoundErrorPage;
    case 500:
      return InternalErrorPage;
    default:
      return GenericErrorPage;
  }
};
